import React, { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { LoginAdapter } from "../../../infraestructure/persistence/rest/LoginAdapter";
import { userData } from "../modules/AuthenticationProvider";

const UserSettingsContext = React.createContext(null);

const UserSettingsProvider =({ children }) =>{

  // const StoragePerfil = localStorage.getItem("perfil-partes");
  // const WrongPerfil = (StoragePerfil===null || typeof StoragePerfil !== 'string' || StoragePerfil === 'undefined' || Array.isArray(StoragePerfil) || StoragePerfil === '[object Object]');

  let logedUserData = userData();
  let [currentUser, setCurrentUser] = useState(logedUserData);
  //let [currentProfile, setCurrentProfile] = useState(WrongPerfil === true ? 'USR': StoragePerfil);

  const haveCurrentUser = useMemo(()=>(currentUser!==undefined && currentUser!==null && Object.keys(currentUser).length>0),[currentUser])

  useEffect(()=> {if(!haveCurrentUser){setCurrentUser(logedUserData)}},[haveCurrentUser,logedUserData])

  //useEffect(()=>{currentProfile && sessionStorage.setItem("perfil-partes",currentProfile);},[currentProfile])

  const getUserSettings = async () => {
    if(haveCurrentUser)
    {
      const api = new LoginAdapter();
      try {
          var result = await api.GetDataUser();
          if(result.data!==undefined && result.data!==''){
            return result.data;
              //const Idioma = localStorage.getItem("language-partes");
              //return {...result.data,...{idioma: Idioma!==null?Idioma:null}}
          }
      } catch (error) {}
    }
  };

  const {data, isError, error , isLoading} = useQuery('getUserSettingsProvider', getUserSettings, {refetchInterval: 30000})
  useEffect(()=> setCurrentUser({...data}),[data])

  return (
    <UserSettingsContext.Provider
      value={{
        currentUser: currentUser,
        setCurrentUser: (newCurrent) => setCurrentUser({ ...newCurrent }),
        //currentProfile: currentProfile,
        // setCurrentProfile: (newProfile) => setCurrentProfile(newProfile),
        //onChangeLanguageUser: (newLanguage) => setCurrentUser({ ...currentUser, ...{idioma: newLanguage} })
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
}

function useUserSettings() {
  const context = React.useContext(UserSettingsContext);

  if (!context) {
    throw new Error(`useUserSettingsContext debe ser usado dentro de useUserSettingsProvider`);
  }

  return context;
}

export { UserSettingsProvider, useUserSettings };